// extracted by mini-css-extract-plugin
export default {"select":"template_selector-module___select___d7f10936","dropdownValue":"template_selector-module___dropdownValue___c0bc0750"};